// @flow
import client from '../../client'

// Endpoints
export const GET_TRAINS_ENDPOINT = '/trains/'

// Types
type APIResponse = {
  rides: Train[],
}
type StationLocation = {
  display_name: string,
  code: string,
}
export type Train = {
  company: string,
  train_number: string,
  origin: StationLocation,
  destination: StationLocation,
  departure_time: string,
  arrival_time: string,
}
type Options = {
  ride_date: string,
  origin_station: string,
  ride_direction: 'departing' | 'arriving',
  destination_station: string,
}

async function getTrains(options: Options): Promise<Train[]> {
  return client
    .get(GET_TRAINS_ENDPOINT, { query: options })
    .then((response: APIResponse): Train[] => response.rides)
}

export default getTrains
